import { DISPLAY_LANG } from '../../config';
import axios from '../../axios';

export const registerDomains = async () => {
    const domainRegistrationContacts = JSON.parse(localStorage.getItem('domain_registration_contacts'));

    if (!domainRegistrationContacts || domainRegistrationContacts.length === 0) {
        return;
    }

    for (const elem of domainRegistrationContacts) {
        try {
            const res = await axios.post('domain/register_domain', elem);

            if (res.data.ok) {
                alert(res.data.domain_name + ' - ' + res.data.message);
            }

            const resHosting = await axios.post('isp/order-hosting', {
                "user_id": elem.user_id,
                "domain": elem.domainName,
                "plan": elem.plan,
                "billing_type": elem.billing_type,
            });

            if (resHosting.status !== 201) {
                throw new Error('Error in pay hostings from cart');
            }

            alert(resHosting.data[DISPLAY_LANG]);
        } catch (error) {
            console.log(error.response.data);

            if (error.response.data.status === 'ERROR') {
                alert(error.response.data.message);
            } else if (error.response.data.message) {
                alert(error.response.data.message);
            } else {
                alert(`${error.response.data.error.actiontypedesc ?? ""}\n${error.response.data.error.error}`);
            }

            localStorage.removeItem('domain_registration_contacts');

            throw error;
        }
    }
}

export const registerHostings = async (orders) => {
    const existingHostings = orders.filter(elem => elem.item_type === "hosting");

    if (existingHostings.length === 0) {
        return;
    }

    for (const hosting of existingHostings) {
        const body = {
            "plan_id": hosting.id,
            "user_id": localStorage.getItem('user_id'),
            "domain": hosting.isp_hosting_connected,
            "plan": hosting.isp_hosting_name,
            "billing_type": hosting.isp_hosting_billing_type,
        };

        try {
            const res = await axios.post('isp/order-hosting', body);

            if (res.status !== 201) {
                throw new Error('Error in pay hostings from cart');
            }

            alert(res.data[DISPLAY_LANG]);
        } catch (error) {
            console.log(error);
            alert(error.message);
            throw error;
        }
    }
}